module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-history"
  }, [_c('div', {
    staticClass: "task-history-container"
  }, [_c('div', {
    staticClass: "task-history-header"
  }, [_vm._v("\n      Task history\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "task-history-body"
  }, [_c('vuescroll', {
    ref: "historyMsg",
    attrs: {
      "ops": _vm.scrollBarOptions
    },
    on: {
      "handle-scroll": _vm.handleScroll
    }
  }, [_vm._l((_vm.taskHistory), function(message) {
    return (_vm.taskHistory.length) ? _c('div', {
      staticClass: "task-history-body-row",
      class: [{
        mine: _vm.isMineMessage(message),
        'not-sent': message.notSent
      }, 'message-type-' + message.type]
    }, [_c('div', {
      staticClass: "task-history-body-message"
    }, [_c('div', {
      staticClass: "task-history-body-message-header"
    }, [(message.type === 1) ? _c('span', {
      staticClass: "task-history-body-message-header-icon"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-user fa-w-14",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "user",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128\n                        128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0\n                        26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.getUserId === message.userId) ? [_vm._v("You")] : [_vm._v(_vm._s(message.userName))], _vm._v(" "), (message.clearOfficer) ? [_vm._v(" (Clear Assured)")] : _vm._e(), _vm._v(" "), (message.clearBot) ? [_vm._v("Clear Bot")] : _vm._e(), _vm._v("\n              | " + _vm._s(message.date) + "\n              "), (message.notSent) ? _c('span', {
      staticClass: "task-history-body-message-header-not-sent"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-exclamation-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "exclamation-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043\n                        8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595\n                        46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373\n                        0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884\n                        0-12.356 5.78-11.981 12.654z"
      }
    })]), _vm._v("\n                Sending failed\n              ")]) : _vm._e(), _vm._v(" "), (message.notSent) ? _c('button', {
      staticClass: "task-history-body-message-header-not-sent-button",
      on: {
        "click": function($event) {
          return _vm.retrySendMessage(message)
        }
      }
    }, [_vm._v("Retry")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "task-history-body-message-content"
    }, [(message.type === 1) ? _c('div', {
      staticClass: "task-history-body-message-text",
      class: {
        'delete-in-progress': _vm.deleteInProgress === message.id
      }
    }, [(message.deleted) ? [_c('i', [_vm._v("Comment deleted by " + _vm._s(message.deletedBy) + " on " + _vm._s(message.deletedOn))])] : _c('div', {
      domProps: {
        "innerHTML": message.text
      }
    }), _vm._v(" "), (message.files && message.files.length) ? _c('div', {
      staticClass: "task-history-body-message-files",
      class: {
        'has-text': message.text && message.text !== ''
      }
    }, [_c('div', {
      staticClass: "task-history-body-message-files-container"
    }, _vm._l((message.files), function(file) {
      return _c('a', {
        staticClass: "task-history-body-message-file",
        attrs: {
          "href": "#",
          "role": "button",
          "target": "_blank"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.downloadFile(file, message.id)
          }
        }
      }, [_vm._v(_vm._s(file.file))])
    }), 0)]) : _vm._e()], 2) : (message.type === 2) ? _c('div', {
      staticClass: "task-history-body-message-text"
    }, [_c('div', {
      staticClass: "task-history-body-message-status"
    }, [_vm._v("\n                  Changed status to\n                  "), (_vm.getStatusById(message.status)) ? _c('span', [_c('span', {
      staticClass: "status-badge",
      class: ['status-' + _vm.getStatusById(message.status)['id']]
    }, [(_vm.getStatusById(message.status)['id'] === 1) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                                  0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                                  168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (_vm.getStatusById(message.status)['id'] === 2) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                                  368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                                  48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                                  48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                                  0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                                  21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (_vm.getStatusById(message.status)['id'] === 3) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                                  55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                                  241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                                  0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (_vm.getStatusById(message.status)['id'] === 4) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                                  256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                                  89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                                  303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                                  16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "status-text"
    }, [_vm._v("\n                          " + _vm._s(_vm.getStatusById(message.status)['name']) + "\n                        ")])], 2)]) : _vm._e()])]) : (message.type === 3) ? _c('div', {
      staticClass: "task-history-body-message-text"
    }, [_c('div', {
      staticClass: "task-history-body-message-assignee"
    }, [_vm._v("\n                  Assigned to\n                  "), _c('span', [_c('span', {
      staticClass: "assignee-badge"
    }, [_c('span', {
      staticClass: "assignee-badge-image"
    }, [(message.assigneeImage || message.assigneeFullName) ? [(message.assigneeImage) ? _c('span', {
      style: ({
        backgroundImage: 'url(' + message.assigneeImage + ')'
      })
    }) : _c('avatar', {
      attrs: {
        "username": message.assigneeFullName,
        "size": 29,
        "color": "#ffffff"
      }
    })] : [_c('svg', {
      staticClass: "svg-inline--fa fa-user-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "user-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 496 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                                  88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                                  55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                                  7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
      }
    })])]], 2), _vm._v(" "), _c('span', {
      staticClass: "assignee-badge-text"
    }, [_vm._v("\n                          " + _vm._s(message.assigneeName) + "\n                        ")])])])])]) : (message.type === 4) ? _c('div', {
      staticClass: "task-history-body-message-text"
    }, [_vm._v("\n                Moved to '" + _vm._s(message.board) + "'\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isMineMessage(message) && message.type === 1 && !message.deleted) ? _c('div', {
      staticClass: "task-history-body-message-actions"
    }, [(!message.notSent && !message.clearBot) ? _c('button', {
      on: {
        "click": function($event) {
          return _vm.deleteMessage(message)
        }
      }
    }, [_vm._v("Delete message")]) : _vm._e()]) : _vm._e()])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.taskHistory.length) ? _c('div', {
    staticClass: "task-history-empty"
  }, [_vm._v("\n          Nothing to see here just yet."), _c('br'), _vm._v("\n          As soon as you start registering progress with this task, you will be able to see here the changes, as well as the messages you send or receive.\n        ")]) : _vm._e()], 2)], 1), _vm._v(" "), _c('form', {
    staticClass: "task-history-footer",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.messageSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "task-history-footer-textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageForm.text),
      expression: "messageForm.text"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "First Name",
      "data-vv-as": "Message",
      "rows": "2",
      "placeholder": "Type in your message...",
      "aria-label": "Message"
    },
    domProps: {
      "value": (_vm.messageForm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.messageForm, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "task-history-footer-actions"
  }, [_c('button', {
    staticClass: "task-history-footer-actions-submit",
    class: {
      'not-empty': _vm.messageForm.text !== '' || _vm.messageForm.files.length, 'submitting': _vm.submitting
    },
    attrs: {
      "type": "submit",
      "aria-label": "Submit message"
    }
  }, [(!_vm.submitting) ? _c('svg', {
    staticClass: "svg-inline--fa fa-paper-plane fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "paper-plane",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9\n                        13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515\n                        7.8 493.3-6.8 476 3.2z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.submitting) ? _c('svg', {
    staticClass: "svg-inline--fa fa-spinner-third fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fad",
      "data-icon": "spinner-third",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('g', {
    staticClass: "fa-group"
  }, [_c('path', {
    staticClass: "fa-secondary",
    attrs: {
      "fill": "currentColor",
      "d": "M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z",
      "opacity": "0.4"
    }
  }), _c('path', {
    staticClass: "fa-primary",
    attrs: {
      "fill": "currentColor",
      "d": "M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z"
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.messageForm.files.length) ? _c('div', {
    staticClass: "task-history-footer-files"
  }, [_c('div', {
    staticClass: "task-history-footer-files-wrapper"
  }, _vm._l((_vm.messageForm.files), function(file, index) {
    return _c('div', {
      staticClass: "task-history-footer-files-item"
    }, [_vm._v("\n              " + _vm._s(file.name) + "\n              "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeMessageFile(index)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-times fa-w-11",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "times",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 352 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19\n                        0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48\n                        0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24\n                        22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                        0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      }
    })])])])
  }), 0)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "task-history-file-button"
  }, [_c('label', {
    attrs: {
      "for": 'uploadResource_' + _vm.taskId
    }
  }, [_c('span', {
    staticClass: "task-history-file-button-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-paperclip fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "paperclip",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332\n                      116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633\n                      30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422\n                      22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236\n                      13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154\n                      0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319\n                      16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "task-history-file-button-text"
  }, [_vm._v("Attach files")]), _vm._v(" "), _c('input', {
    staticClass: "visually-hidden",
    attrs: {
      "type": "file",
      "name": "Files",
      "multiple": "",
      "id": 'uploadResource_' + _vm.taskId
    },
    on: {
      "change": function($event) {
        return _vm.processFiles($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "task-history-file-info"
  }, [_vm._v("\n    Files attached shouldn't be larger than 1 MB."), _c('br'), _vm._v("\n    Accepted formats: " + _vm._s(_vm.taskMessageAllowedFileFormats.join(', ')) + ".\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dce41de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tasks/includes/TaskHistory.vue
// module id = 974
// module chunks = 0